export default "__VITE_ASSET__884262f2__"